import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-044dbd40");

var _hoisted_1 = {
  class: "address-info"
};
var _hoisted_2 = {
  class: "button-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_address_edit = _resolveComponent("van-address-edit");

  var _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_address_edit, {
    ref: "addressList",
    "area-list": $data.areaList,
    "address-info": $data.addressInfo,
    "show-search-result": "",
    "search-result": $data.searchResult,
    "area-columns-placeholder": ['请选择', '请选择', '请选择'],
    "tel-validator": $options.validator,
    "save-button-text": $props.saveText,
    "show-area": $data.showArea,
    onSave: $options.onSave
  }, null, 8, ["area-list", "address-info", "search-result", "tel-validator", "save-button-text", "show-area", "onSave"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_button, {
    block: "",
    plain: "",
    round: "",
    size: "normal",
    type: "primary",
    color: "#FC9224",
    onClick: $options.onClickClose
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString($props.cancelText), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])])]);
}